export default {
  accepted: {
    title: 'Assinatura aceita',
    description: 'Assinatura aceita. Obrigado por usar nosso serviço de entrega!',
  },
  info: 'Você tem uma entrega de',
  title: 'Verifique seus dados:',
  fields: {
    name: 'Nome do destinatário:',
    phone: 'Telefone do destinatário:',
    address: 'Endereço do destinatário:',
    'rx-number': 'Número da receita (Rx):',
  },
  'action-btn': 'Enviar',
  'empty-signature': 'Desenhe sua assinatura antes de enviar.',
  'heading-required': 'Assinatura obrigatória',
  'heading-optional': 'Assinatura opcional',
  'heading-change': 'Você já assinou. Deseja alterar sua assinatura?',
}
